import {
  largeWidthBreakPoint,
  masterBreakPoint,
  maxWidth600,
} from "themes/default/breakpoints"
import { modalContent } from "themes/default/mixins"

export const styles = {
  title: {
    px: 2,
    [masterBreakPoint]: {
      fontSize: 20,
    },
    [maxWidth600]: {
      fontSize: 16,
      px: 1,
    },
    [largeWidthBreakPoint]: {
      fontSize: 16,
      p: 0,
    },
  },
  top: {
    pt: 4,
    [masterBreakPoint]: {
      pt: 1,
    },
    [maxWidth600]: {
      pt: 0,
    },
    [largeWidthBreakPoint]: {
      pt: 0,
    },
  },
  paper: (theme) => ({
    ...modalContent,
    maxWidth: 800,
    backgroundColor: theme.palette.background.orange,
    px: 2,
    [maxWidth600]: {
      px: 2,
    },
  }),
  closeButton: (theme) => ({
    position: "absolute",
    right: 8,
    top: 8,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.background.default,
  }),
  icon: (theme) => ({
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.black
        : theme.palette.background.default,
  }),
  input: (theme) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: 3,
    outline: "none",
    "& label.Mui-focused": {
      borderColor: "transparent",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "transparent",
      },
    },
    "& textarea": {
      color: theme.palette.common.black,
      fontSize: 25,
      lineHeight: "28px",
      [masterBreakPoint]: {
        fontSize: 16,
        lineHeight: "18px",
      },
    },
  }),
  button: {
    textTransform: "none",
  },
  content: {
    p: 2,
    backgroundColor: "transparent",
    [maxWidth600]: {
      padding: 0,
    },
  },
  removeIcon: (theme) => ({
    color: "white",
    backgroundColor: "red",
    borderRadius: "50%",
    border: "none",
    fontSize: 15,
    cursor: "pointer",
  }),
  removeButton: {
    p: 0,
  },
  tourOpen: (theme) => ({
    zIndex: 10000,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  }),
  inputTour: {
    zIndex: 10000,
  },
  actions: {
    px: 2,
  },
}
